import { SubscriptionActionCapabilities } from '@urc-ui/utils/subscription-utils';

export interface ActionDropdownProps {
  onRunReport: () => void;
  onCopyReport: () => void;
  onDeleteReport: () => void;
  capabilities?: SubscriptionActionCapabilities;
}

export interface ModalFooterProps {
  onCloseModel: () => void;
  onDeleteReport: () => void;
}

export enum ActionType {
  Run = 'run',
  Copy = 'copy',
  Delete = 'delete'
}
